(function () {
  var WIDGET = '.ws_inr_main_wgt';
  var BTN = '.evm-ws__cart-submit';
  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var killedIds = {};
  var styleEl = null;
  /* Wiser renders its own default font; force it to match the theme's
   * product-card typography (--font-body, set in theme.css). */
  var styleRules = WIDGET + ', ' + WIDGET + ' *{font-family:var(--font-body)!important;}';
  var awaitingWiserAdd = false;

  /* Wiser's own add-to-cart call bypasses the theme's cart-drawer.js form
   * handler entirely, so the drawer never repaints even though the cart
   * total updates. Watch for its /cart/add network call and refresh the
   * drawer ourselves once it resolves. */
  function refreshDrawerAfterAdd() {
    if (!window.cartDrawer || typeof window.cartDrawer.refresh !== 'function') return;
    window.cartDrawer.refresh().then(function () {
      if (typeof window.cartDrawer.open === 'function') window.cartDrawer.open();
    });
  }

  function patchNetworkForCartDrawerSync() {
    if (window.__wrfNetworkPatched) return;
    window.__wrfNetworkPatched = true;

    /* Capture phase runs before the target's own onclick (e.g.
     * evm_addtocart / evm_alsobought_addtocart), across every Wiser
     * add-to-cart button on the page — the recently-viewed widget, the
     * frequently-bought-together widget, etc. — not just the ones we
     * visually patch with a cover span. */
    document.addEventListener('click', function (e) {
      if (!(e.target.closest && e.target.closest(BTN))) return;
      awaitingWiserAdd = true;
      /* Fallback: some Wiser widgets (e.g. frequently-bought-together)
       * don't add to cart via a fetch/XHR call we can pattern-match — if
       * we never spot a matching /cart/add request, refresh anyway once
       * the add has almost certainly finished. */
      setTimeout(function () {
        if (!awaitingWiserAdd) return;
        awaitingWiserAdd = false;
        refreshDrawerAfterAdd();
      }, 1500);
    }, true);

    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var watch = awaitingWiserAdd && CART_ADD_RE.test(url);
        var promise = origFetch.apply(this, arguments);
        if (watch) {
          awaitingWiserAdd = false;
          promise.then(function (res) {
            if (res && res.ok) refreshDrawerAfterAdd();
            return res;
          });
        }
        return promise;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__wrfCartAdd = CART_ADD_RE.test(url);
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__wrfCartAdd && awaitingWiserAdd) {
        awaitingWiserAdd = false;
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) refreshDrawerAfterAdd();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  /* Keep a single <style> element at the very end of <body> so our rules
   * always appear last in the author cascade regardless of when Wiser injects. */
  function getStyleEl() {
    if (styleEl && styleEl.isConnected) return styleEl;
    styleEl = document.createElement('style');
    styleEl.setAttribute('data-wrf', '');
    styleEl.textContent = styleRules;
    document.body.appendChild(styleEl);
    return styleEl;
  }

  function keepStyleLast(mutationList) {
    var moved = false;
    mutationList.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n !== styleEl && n.nodeType === 1 &&
            (n.tagName === 'STYLE' || n.tagName === 'LINK')) {
          moved = true;
        }
      });
    });
    if (moved) document.body.appendChild(styleEl); /* moves to end */
  }

  function killId(id) {
    if (killedIds[id]) return;
    killedIds[id] = true;
    /* Set ::after display:none so it cannot paint over our cover span */
    styleRules +=
      '#' + id + '::before,' +
      '#' + id + '::after,' +
      '#' + id + ' .ws_ls_lang::before,' +
      '#' + id + ' .ws_ls_lang::after{' +
        'content:none!important;' +
        'display:none!important;' +
        'background:none!important;' +
        'background-image:none!important;' +
        'visibility:hidden!important;}';
    getStyleEl().textContent = styleRules;
  }

  function fixButton(btn) {
    if (btn.id) killId(btn.id);

    /* Cover span — guards on element presence so re-rendered buttons get fixed */
    if (btn.querySelector('[data-wrf-cover]')) return;

    var label = btn.querySelector('.ws_ls_lang');
    if (label) label.style.setProperty('display', 'none', 'important');

    var cover = document.createElement('span');
    cover.setAttribute('data-wrf-cover', '');
    cover.textContent = 'Add to cart';

    /* visibility:visible overrides the inherited visibility:hidden from the
     * button only for real DOM elements — pseudo-elements cannot override
     * inherited visibility, so ::after stays hidden. */
    var coverProps = {
      visibility: 'visible',
      position: 'absolute',
      top: '0', left: '0', right: '0', bottom: '0',
      width: '100%', height: '100%',
      margin: '0', padding: '0',
      'box-sizing': 'border-box',
      display: 'flex',
      'flex-direction': 'row',
      'align-items': 'center',
      'justify-content': 'center',
      'text-align': 'center',
      'vertical-align': 'middle',
      'line-height': '1',
      background: 'var(--accent)',
      color: '#fff',
      'z-index': '2147483647',
      'font-size': '0.84rem',
      'font-weight': '600',
      'letter-spacing': '-0.01em',
      'text-transform': 'none',
      'border-radius': 'inherit'
    };
    Object.keys(coverProps).forEach(function (prop) {
      cover.style.setProperty(prop, coverProps[prop], 'important');
    });

    btn.style.setProperty('position', 'relative', 'important');
    btn.style.setProperty('overflow', 'hidden', 'important');
    /* visibility:hidden hides the button's own content including ::after;
     * real child elements can override with visibility:visible */
    btn.style.setProperty('visibility', 'hidden', 'important');
    btn.appendChild(cover);
  }

  function fixAll(root) {
    root.querySelectorAll(WIDGET + ' ' + BTN).forEach(fixButton);
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchNetworkForCartDrawerSync();
    getStyleEl();
    new MutationObserver(keepStyleLast).observe(document.body, { childList: true });

    fixAll(document);

    var widget = document.querySelector(WIDGET);
    if (!widget) return;
    new MutationObserver(function () { fixAll(widget); })
      .observe(widget, { childList: true, subtree: true });
  });
})();
